import { render, staticRenderFns } from "./languageList.vue?vue&type=template&id=72cd1b69&scoped=true&"
import script from "./languageList.vue?vue&type=script&lang=js&"
export * from "./languageList.vue?vue&type=script&lang=js&"
import style0 from "./languageList.vue?vue&type=style&index=0&id=72cd1b69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd1b69",
  null
  
)

export default component.exports